import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import logo from "../resources/images/logo.png";
import {
  openSignInModal,
  openSignUpModal,
  openPasswordRecoveryModal,
  signOut
} from "../modules/account/accountActions";
import { Button, Menu, MenuItem } from "@mui/material";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import constants from "../config/constants";

class Header extends Component {
  constructor() {
    super();
    this.state = {
      anchorEl: null
    }
  }

  handleClickOpen(event) {
    this.setState({
      ...this.state,
      anchorEl: event.currentTarget
    })
  }

  handleClickClose() {
    this.setState({
      ...this.state,
      anchorEl: null
    })
  }

  openSignInModal() {
    this.props.openSignInModal();
  }

  openSignUpModal() {
    this.props.openSignUpModal();
  }

  signOut() {
    this.props.signOut();
  }

  render() {
    const headerClasses =
      this.props.location.pathname === "/"
        ? "header d-flex flex-row flex-space-between py-2"
        : "header d-flex flex-row flex-space-between py-2 bg-blue-accent-3";
    if (this.props.user) {
      return (
        <header className="header-position">
          <div className={headerClasses}>
            <a onClick={() => window.location.href = `${constants.SIMULADO_V2_URL}`} name="Logo" >
              <img
                className="header__logo"
                src={logo}
                alt="Logo do Beduka"
              ></img>
            </a>
            <div className="header__items d-flex flex-row">
              {/* <a
                onClick={(event) => this.handleClickOpen(event)}
                className="profile-dropdown btn btn-dropdown btn--underlined-white bg-transparent white my-auto mr-2"
              >
                {this.props.user.firstName} <ArrowDropDown />
              </a> */}
              <Button
                className="btn underline btn--underlined-white-on-hover"
                variant='contained'
                onClick={(event) => this.handleClickOpen(event)}
                sx={{
                  marginY: 'auto',
                  marginRight: '10px',
                  backgroundColor: '#007bff',
                  boxShadow: 0,
                  '&:hover': {
                    backgroundColor: '#007bff',
                    opacity: '0.8'
                  }
                }}
                endIcon={ !this.state.anchorEl ? <ArrowDropDown/> : <ArrowDropUp/> }
              >
                {this.props.user.firstName}
              </Button>
              <Menu
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl)}
                onClose={() => this.handleClickClose()}
              >
                <MenuItem
                  autoFocus={false}
                  component={Link}
                  to='/meus-simulados'
                  onClick={() => this.handleClickClose()}
                >
                  Meus simulados
                </MenuItem>
              </Menu>
              <a
                onClick={() => this.signOut()}
                className="btn btn--underlined-white-on-hover bg-transparent white my-auto"
              >
                Sair
              </a>
            </div>
          </div>
        </header>
      );
    } else {
      return (
        <header className="header-position">
          <div className={headerClasses}>
            <Link to="/" name="Logo">
              <img
                className="header__logo"
                src={logo}
                alt="Logo do Beduka"
              ></img>
            </Link>
            <div className="header__items d-flex flex-row">
              <a
                onClick={() => this.openSignInModal()}
                className="btn btn--underlined-white-on-hover bg-transparent white my-auto mr-2"
              >
                Entrar
              </a>
              <a
                onClick={() => this.openSignUpModal()}
                className="btn btn--underlined-white-on-hover bg-transparent white my-auto"
              >
                Cadastrar
              </a>
            </div>
          </div>
        </header>
      );
    }
  }
}

const mapStateToProps = state => ({
  user: state.account.user
});

const HeaderWithRouter = withRouter(
  connect(mapStateToProps, {
    openSignInModal,
    openSignUpModal,
    openPasswordRecoveryModal,
    signOut
  })(withRouter(Header))
);

export { HeaderWithRouter as Header };
